import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAgent } from '@codes/agents';

import { AgentForm } from '../components/AgentForm';
import { useAgentSettings } from '../hooks/useAgentSettings';

export const AgentCatalogSettingsPage = () => {
    const { t } = useTranslation();
    const { agentId, handleFormSuccess } = useAgentSettings();
    const { data: agent, isLoading: isAgentLoading } = useAgent(agentId || '', !!agentId);

    if (!agentId) {
        return null;
    }

    if (isAgentLoading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center">
                    <div className="w-8 h-8 animate-spin rounded-full border-2 border-border border-t-primary mx-auto mb-4" />
                    <p className="text-muted-foreground">{t('agent.catalog.loading.agentSettings')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-background py-8 px-9 max-xs:px-6 w-full flex justify-center">
            <AgentForm mode="edit" agentId={agentId} onFormSuccess={handleFormSuccess} />
        </div>
    );
};
